<template>
    <article class="cmp cmp-product-thumb"
             @mouseenter="enableSelection"
             @mouseleave="pauseSelection">

        <div :class="paddingClasses"
             :style="paddingInlineStyles">
            <div class="thumb-image">

                <mh-category-item-image :item="item"
                                        :url-with-variation-id="urlWithVariationId"
                                        :lazy="position === -1 || position > 4"
                                        ref="itemImages"></mh-category-item-image>
                <!-- STORE SPECIALS -->
                <lazy-hydrate never>
                    <mh-category-variation-tags
                        :variation-properties="item.variationProperties"></mh-category-variation-tags>
                </lazy-hydrate>
                <!-- ./STORE SPECIALS -->
            </div>

            <mh-add-to-wish-list :variation-id="item.variation.id"
                                 :item-id="item.item.id"
                                 hide-text
                                 @item-added="onItemAddToWishList"></mh-add-to-wish-list>

            <!-- ITEM DETAILS -->
            <slot name="item-details">
                <div class="thumb-content">
                    <mh-category-variation-selection v-if="showVariations"
                                                     ref="categoryVariationSelection"
                                                     :item="item"
                                                     :variationId="item.variation.id"
                                                     :variationProperties="item.variationProperties"
                                                     @image:overwrite="(ev) => $refs.itemImages.overwriteImage(ev)"
                    ></mh-category-variation-selection>
                    <a :href="item | itemURL(urlWithVariationId)"
                       class="pt-2 thumb-title">
                        <span class="thumb-title-manufacturer">{{ item.item.manufacturer.externalName }}</span><br>
                        {{ productTitle | truncate(95) }}
                    </a>
                    <slot name="before-prices"></slot>
                    <lazy-hydrate never>
                        <mh-category-variation-price :item="item"
                                                     :minimumAbsoluteValue="crossPriceMinimumAbsoluteValue"
                                                     :minimumPercentageValue="crossPriceMinimumPercentage"
                                                     :youSaveText="$translate('modeherz::CategoryPageClient.categoryPageItemYouSave')"
                        ></mh-category-variation-price>
                    </lazy-hydrate>
                    <slot name="after-prices"></slot>
                    <div class="category-unit-price small"
                         v-if="!(item.unit.unitOfMeasurement === 'C62' && item.unit.content === 1)">
                        <span>{{ item.unit.content }}</span>
                        <span>&nbsp;{{ item.unit.names.name }}</span>
                        <span v-if="item.variation.mayShowUnitPrice">&nbsp;| {{ item.prices.default.basePrice }}</span>
                    </div>

                </div>

            </slot>

            <!-- ./ITEM DETAILS  -->
        </div>
    </article>
</template>

<script>
    import { mapState } from 'vuex';
    import { getSlotData } from '../../helper/getSlotData';
    import { isBreakpointUp } from '../../../modeherz/helpers/device-size-check';
    import productTitleMixin from '../../../modeherz/mixins/propertyValue';
    export default {

        props: {
            decimalCount:
                {
                    type: Number,
                    default: 0,
                },
            imageUrlAccessor:
                {
                    type: String,
                    default: 'urlMiddle',
                },
            itemData:
                {
                    type: Object,
                },
            disableCarouselOnMobile:
                {
                    type: Boolean,
                },
            paddingClasses:
                {
                    type: String,
                    default: null,
                },
            paddingInlineStyles:
                {
                    type: String,
                    default: null,
                },
            forceUrlWithVariationId:
                {
                    type: Boolean,
                    default: false,
                },
            position: {
                type: Number,
                default: -1,
            },
        },
        mixins:[productTitleMixin],
        jsonDataFields: [
            'itemDataRef',
        ],

        data() {
            return {
                crossPriceMinimumAbsoluteValue: App.modeherzPluginConfig.prices.crossPrice.minimumAbsoluteValue,
                crossPriceMinimumPercentage: App.modeherzPluginConfig.prices.crossPrice.minimumPercentage,
                deviceToSmall: true,
                showVariations: false,
            };
        },
        mounted() {
            this.deviceToSmall = !isBreakpointUp('md');
        },
        computed:
            {
                item() {
                    return this.itemData || this.itemSlotData || this.itemDataRef;
                },

                itemSlotData: getSlotData('item-data'),

                /**
                 * returns itemData.item.storeSpecial
                 */
                storeSpecial() {
                    return this.item.item.storeSpecial;
                },

                /**
                 * returns itemData.texts
                 */
                texts() {
                    return this.item.texts;
                },

                itemPrice() {
                    return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, 'unitPrice', 'formatted');
                },

                basePrice() {
                    return this.item.prices.default.basePrice;
                },

                itemPriceGraduated() {
                    let unitPrice;
                    if (App.config.item.enableGraduatedPrices) {
                        unitPrice = this.item.prices.graduatedPrices.length > 0
                            ? this.item.prices.graduatedPrices[0].unitPrice
                            : this.item.prices.default.unitPrice;
                    } else {
                        unitPrice = this.item.prices.default.unitPrice;
                    }

                    return this.$options.filters.specialOffer(unitPrice.formatted, this.item.prices, 'unitPrice', 'formatted');
                },

                itemGraduatedPriceisCheapestSorting() {
                    return !!this.item.item && this.item.item.salableVariationCount > 1 && !!this.$ceres.isCheapestSorting;
                },

                itemGraduatedPricesalableVariationCount() {
                    return !!this.item.item && this.item.item.salableVariationCount == 1 && this.item.prices.graduatedPrices.length > 1 && App.config.item.enableGraduatedPrices;
                },

                itemSetPrice() {
                    return this.$options.filters.currency(
                        this.item.prices.default.price.value,
                        this.item.prices.default.currency,
                    );
                },

                urlWithVariationId() {
                    return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
                },

                productTitle(){
                    const defaultValue = this.item.texts.name1?.replace(this.item.item.manufacturer.externalName, '');
                    // const productTitle = this.getProductTitle(this.item.variationProperties,81, defaultValue)
                    return defaultValue;
                },

                ...mapState({
                    showNetPrices: state => state.basket.showNetPrices,
                }),
            },
        methods: {
            enableSelection() {
                if (this.deviceToSmall)
                    return;
                if (!this.showVariations) {
                    this.showVariations = true;
                } else {
                    this.$refs.categoryVariationSelection?.setVisible(this.$el);
                }
            },
            pauseSelection() {
                if (this.deviceToSmall)
                    return;
                this.$refs.categoryVariationSelection?.setPause(this.$el);
            },
            onItemAddToWishList() {
                document.dispatchEvent(new CustomEvent('onItemAddToWishList', {
                    detail: {
                        id: this.item.variation.id,
                        number: this.item.variation.number,
                        name: this.item.texts.name1,
                        price: this.item.prices.default.data.price.toFixed(2),
                        priceNet: this.item.prices.default.data.priceNet.toFixed(2),
                        amount: this.item.prices.default.data.price.toFixed(2),
                        amountNet: this.item.prices.default.data.priceNet.toFixed(2),
                        rrp: this.item.prices.rrp.data.priceNet.toFixed(2),
                        rrpNet: this.item.prices.rrp.data.priceNet.toFixed(2),
                        brand: this.item.item.manufacturer.externalName,
                        quantity: 1,
                    },
                }));
            },
        },
    };
</script>
